import React from 'react'
import { FeatureTestimonial } from '../../elements/FeatureTestimonial'
import { ImageOrAutoplayVideo } from '../../elements/ImageOrAutoplayVideo'
import { FeatureSpotlightBase } from '../FeatureSpotlightBase'
import { IProps } from './index'

export const FeatureSpotlightTestimonial = (props: IProps) => {
  const renderMedia = () => {
    const { productImgRef, productVideo, productVideoWebm } = props
    return (
      <ImageOrAutoplayVideo
        imageRef={productImgRef}
        video={productVideo}
        videoWebm={productVideoWebm}
      />
    )
  }
  const { testimonial } = props
  return (
    <FeatureSpotlightBase {...props} isZippered renderMedia={renderMedia}>
      <FeatureTestimonial {...testimonial} />
    </FeatureSpotlightBase>
  )
}
